import {
  GET_SHIFT_SUMMARY_SUCCESS,
  GET_SHIFT_SUMMARY_FAIL,
  SET_GET_SHIFT_SUMMARY_LOADING,
  GET_DAILY_SUMMARY_SUCCESS,
  GET_DAILY_SUMMARY_FAIL,
  SET_GET_DAILY_SUMMARY_LOADING,
  GET_DAILY_CHART_SUCCESS,
  GET_DAILY_CHART_FAIL,
  SET_GET_DAILY_CHART_LOADING,
  GET_PAYMENT_LEDGER_SUCCESS,
  GET_PAYMENT_LEDGER_FAIL,
  SET_GET_PAYMENT_LEDGER_LOADING,
  GET_PAYMENT_LEDGER_METHODS_SUCCESS,
  GET_PAYMENT_LEDGER_METHODS_FAIL,
  SET_GET_PAYMENT_LEDGER_METHODS_LOADING,
  GET_BUSINESS_DAY_PARTICIPATION_SUCCESS,
  GET_BUSINESS_DAY_PARTICIPATION_FAIL,
  SET_GET_BUSINESS_DAY_PARTICIPATION_LOADING,
} from '../actions/types';

const initialState = {
  shiftSummaryData: [],
  totalRecords: 0,
  currentPage: 1,
  itemsPerPage: 10,
  totalPages: 0,
  hasNextPage: false,
  hasPreviousPage: false,
  startRecord: 0,
  endRecord: 0,
  isGetShiftSummaryLoading: false,
  isGetShiftSummarySuccess: false,
  isGetShiftSummaryError: false,
  getShiftSummaryError: null,
  dailySummaryData: [],
  dailyTotalRecords: 0,
  dailyCurrentPage: 1,
  dailyItemsPerPage: 10,
  dailyTotalPages: 0,
  dailyHasNextPage: false,
  dailyHasPreviousPage: false,
  dailyStartRecord: 0,
  dailyEndRecord: 0,
  isGetDailySummaryLoading: false,
  isGetDailySummarySuccess: false,
  isGetDailySummaryError: false,
  getDailySummaryError: null,
  dailyChartData: { dates: [], series: [] },
    isGetDailyChartLoading: false,
    isGetDailyChartSuccess: false,
    isGetDailyChartError: false,
    getDailyChartError: null,
    paymentLedgerData: [],
    paymentLedgerTotalRecords: 0,
    paymentLedgerCurrentPage: 1,
    paymentLedgerItemsPerPage: 10,
    paymentLedgerTotalPages: 0,
    paymentLedgerHasNextPage: false,
    paymentLedgerHasPreviousPage: false,
    paymentLedgerStartRecord: 0,
    paymentLedgerEndRecord: 0,
    isGetPaymentLedgerLoading: false,
    isGetPaymentLedgerSuccess: false,
    isGetPaymentLedgerError: false,
    getPaymentLedgerError: null,
    paymentLedgerMethods: [],
    defaultPaymentLedgerMethodId: null,
    isGetPaymentLedgerMethodsLoading: false,
    getPaymentLedgerMethodsError: null,
    businessDayData: [],
    businessDayTotalRecords: 0,
    businessDayCurrentPage: 1,
    businessDayTotalPages: 0,
    businessDayHasNextPage: false,
    businessDayHasPreviousPage: false,
    isGetBusinessDayLoading: false,
    getBusinessDayError: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_GET_SHIFT_SUMMARY_LOADING:
      return {
        ...state,
        isGetShiftSummaryLoading: payload,
      };

    case GET_SHIFT_SUMMARY_SUCCESS:
      return {
        ...state,
        shiftSummaryData: payload.data || [],
        totalRecords: payload.pagination?.totalRecords || 0,
        currentPage: payload.pagination?.currentPage || 1,
        itemsPerPage: payload.pagination?.itemsPerPage || 10,
        totalPages: payload.pagination?.totalPages || 0,
        hasNextPage: payload.pagination?.hasNextPage || false,
        hasPreviousPage: payload.pagination?.hasPreviousPage || false,
        startRecord: payload.pagination?.startRecord || 0,
        endRecord: payload.pagination?.endRecord || 0,
        isGetShiftSummarySuccess: true,
        isGetShiftSummaryError: false,
        getShiftSummaryError: null,
      };

    case GET_SHIFT_SUMMARY_FAIL:
      return {
        ...state,
        isGetShiftSummarySuccess: false,
        isGetShiftSummaryError: true,
        getShiftSummaryError: payload,
        shiftSummaryData: [],
        currentPage: 1,
        itemsPerPage: 10,
        totalRecords: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
        startRecord: 0,
        endRecord: 0,
      };

    case SET_GET_DAILY_SUMMARY_LOADING:
      return {
        ...state,
        isGetDailySummaryLoading: payload,
      };

    case GET_DAILY_SUMMARY_SUCCESS:
      return {
        ...state,
        dailySummaryData: payload.data || [],
        dailyTotalRecords: payload.pagination?.totalRecords || 0,
        dailyCurrentPage: payload.pagination?.currentPage || 1,
        dailyItemsPerPage: payload.pagination?.itemsPerPage || 10,
        dailyTotalPages: payload.pagination?.totalPages || 0,
        dailyHasNextPage: payload.pagination?.hasNextPage || false,
        dailyHasPreviousPage: payload.pagination?.hasPreviousPage || false,
        dailyStartRecord: payload.pagination?.startRecord || 0,
        dailyEndRecord: payload.pagination?.endRecord || 0,
        isGetDailySummarySuccess: true,
        isGetDailySummaryError: false,
        getDailySummaryError: null,
      };

    case GET_DAILY_SUMMARY_FAIL:
      return {
        ...state,
        isGetDailySummarySuccess: false,
        isGetDailySummaryError: true,
        getDailySummaryError: payload,
        dailySummaryData: [],
        dailyCurrentPage: 1,
        dailyItemsPerPage: 10,
        dailyTotalRecords: 0,
        dailyTotalPages: 0,
        dailyHasNextPage: false,
        dailyHasPreviousPage: false,
        dailyStartRecord: 0,
        dailyEndRecord: 0,
      };

    case SET_GET_DAILY_CHART_LOADING:
      return {
        ...state,
        isGetDailyChartLoading: payload,
      };

    case GET_DAILY_CHART_SUCCESS:
      return {
        ...state,
        dailyChartData: payload || { dates: [], series: [] },
        isGetDailyChartSuccess: true,
        isGetDailyChartError: false,
        getDailyChartError: null,
      };

    case GET_DAILY_CHART_FAIL:
      return {
        ...state,
        isGetDailyChartSuccess: false,
        isGetDailyChartError: true,
        getDailyChartError: payload,
        dailyChartData: { dates: [], series: [] },
      };

    case SET_GET_PAYMENT_LEDGER_LOADING:
      return {
        ...state,
        isGetPaymentLedgerLoading: payload,
      };

    case GET_PAYMENT_LEDGER_SUCCESS:
      return {
        ...state,
        paymentLedgerData: payload.data || [],
        paymentLedgerTotalRecords: payload.pagination?.totalRecords || 0,
        paymentLedgerCurrentPage: payload.pagination?.currentPage || 1,
        paymentLedgerItemsPerPage: payload.pagination?.itemsPerPage || 10,
        paymentLedgerTotalPages: payload.pagination?.totalPages || 0,
        paymentLedgerHasNextPage: payload.pagination?.hasNextPage || false,
        paymentLedgerHasPreviousPage: payload.pagination?.hasPreviousPage || false,
        paymentLedgerStartRecord: payload.pagination?.startRecord || 0,
        paymentLedgerEndRecord: payload.pagination?.endRecord || 0,
        isGetPaymentLedgerSuccess: true,
        isGetPaymentLedgerError: false,
        getPaymentLedgerError: null,
      };

    case GET_PAYMENT_LEDGER_FAIL:
      return {
        ...state,
        isGetPaymentLedgerSuccess: false,
        isGetPaymentLedgerError: true,
        getPaymentLedgerError: payload,
        paymentLedgerData: [],
        paymentLedgerCurrentPage: 1,
        paymentLedgerItemsPerPage: 10,
        paymentLedgerTotalRecords: 0,
        paymentLedgerTotalPages: 0,
        paymentLedgerHasNextPage: false,
        paymentLedgerHasPreviousPage: false,
        paymentLedgerStartRecord: 0,
        paymentLedgerEndRecord: 0,
      };

    case SET_GET_PAYMENT_LEDGER_METHODS_LOADING:
      return {
        ...state,
        isGetPaymentLedgerMethodsLoading: payload,
      };

    case GET_PAYMENT_LEDGER_METHODS_SUCCESS:
      return {
        ...state,
        paymentLedgerMethods: payload.data || [],
        defaultPaymentLedgerMethodId: payload.defaultCompanyPaymentMethodId || null,
        getPaymentLedgerMethodsError: null,
      };

    case GET_PAYMENT_LEDGER_METHODS_FAIL:
      return {
        ...state,
        paymentLedgerMethods: [],
        defaultPaymentLedgerMethodId: null,
        getPaymentLedgerMethodsError: payload,
      };

    case SET_GET_BUSINESS_DAY_PARTICIPATION_LOADING:
      return {
        ...state,
        isGetBusinessDayLoading: payload,
      };

    case GET_BUSINESS_DAY_PARTICIPATION_SUCCESS:
      return {
        ...state,
        businessDayData: payload.data || [],
        businessDayTotalRecords: payload.pagination?.totalRecords || 0,
        businessDayCurrentPage: payload.pagination?.currentPage || 1,
        businessDayTotalPages: payload.pagination?.totalPages || 0,
        businessDayHasNextPage: payload.pagination?.hasNextPage || false,
        businessDayHasPreviousPage: payload.pagination?.hasPreviousPage || false,
        getBusinessDayError: null,
      };

    case GET_BUSINESS_DAY_PARTICIPATION_FAIL:
      return {
        ...state,
        businessDayData: [],
        businessDayTotalRecords: 0,
        businessDayCurrentPage: 1,
        businessDayTotalPages: 0,
        businessDayHasNextPage: false,
        businessDayHasPreviousPage: false,
        getBusinessDayError: payload,
      };

    default:
      return state;
  }
}
